module.exports = require("blueimp-load-image/js/load-image-exif");